import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ShadowScrollService {
  public showShadowBottom: boolean = false;
  public showShadowTop: boolean = false;

  scroll(e: any) {
    const listHeight = e.target.offsetHeight;
    const listScrollHeight = e.target.scrollHeight;
    const scrollLocation = e.target.scrollTop;
    const limit = listScrollHeight - listHeight - 10;

    if (scrollLocation > limit) {
      this.showShadowBottom = false;
    } else {
      this.showShadowBottom = true;
    }

    this.showShadowTop = scrollLocation > 0;
  }
}
